/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Card_TitleInputs */

const cs_import_card_title = /** @type {(inputs: Import_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import z konkurence / CSV`)
};

const en_import_card_title = /** @type {(inputs: Import_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Competitor / CSV import`)
};

/**
* | output |
* | --- |
* | "Competitor / CSV import" |
*
* @param {Import_Card_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_card_title = /** @type {((inputs?: Import_Card_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Card_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_card_title(inputs)
	return cs_import_card_title(inputs)
});